import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Subject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  private loadingIndicator: any = {};
  private globalLoadingIndicator = new Subject<any>();

  constructor(
    @Inject('API_ENDPOINT') private apiUrl: string,
    private http: HttpClient
  ) { }

  public setLoadingIndicator(subject: Subject<any>, scope = 'default') {
    this.loadingIndicator[scope] = subject;
  }

  public getGlobalLoadingIndicator() {
    return this.globalLoadingIndicator;
  }

  public list(action: string, params: any = {}, options: any = {}) {

    const url = `${this.apiUrl}`;
    const _options = {
      params: {
        action,
        ...params,
      },
      ...options
    };

    this.emitEvent(action, 'list', 'pre', params);
    return this.http.get(url, _options)
      .pipe(
        tap(() => this.emitEvent(action, 'list', 'post', params)),
        catchError((err) => {
          this.emitEvent(action, 'list', 'post', params);
          return throwError(err);
        })
      );

  }

  public get(action: string, params: any = {}, options: any = {}, random = false) {

    const url = !random ? `${this.apiUrl}` : `${this.apiUrl}?r=${uuidv4()}`;
    const _options = {
      params: {
        action,
        ...params,
      },
      ...options
    };

    this.emitEvent(action, 'get', 'pre', params);
    return this.http.get(url, _options)
      .pipe(
        tap(() => this.emitEvent(action, 'get', 'post', params)),
        catchError((err) => {
          console.error(err)
          this.emitEvent(action, 'get', 'post', params);
          return throwError(err);
        })
      );

  }

  public update(action: string, body: any, params: any = {}, options: any = {}) {

    const url = `${this.apiUrl}`;
    const _options = {
      params: {
        action,
        ...params,
      },
      ...options
    };

    let form = new FormData();
    for (const key in body) {

      const value = body[key];
      if (value !== null) {
        if (typeof value === 'object')
          form.append(key, JSON.stringify(value));
        else form.append(key, value);
      }

    }

    this.emitEvent(action, 'update', 'pre', params);
    return this.http.put(url, form, _options)
      .pipe(
        tap(() => this.emitEvent(action, 'update', 'post', params)),
        catchError((err) => {
          this.emitEvent(action, 'update', 'post', params);
          return throwError(err);
        })
      );

  }

  public save(action: string, body: any, params: any = {}, options: any = {}) {

    const url = `${this.apiUrl}`;
    const _options = {
      params: {
        action,
        ...params,
      },
      ...options
    };

    let form = new FormData();
    for (const key in body) {

      const value = body[key];
      if (value !== null) {
        if (typeof value === 'object' && !(value instanceof File))
          form.append(key, JSON.stringify(value));
        else form.append(key, value);
      }

    }

    this.emitEvent(action, 'save', 'pre', params);
    return this.http.post(url, form, _options)
      .pipe(
        tap(() => this.emitEvent(action, 'save', 'post', params)),
        catchError((err) => {
          this.emitEvent(action, 'save', 'post', params);
          return throwError(err);
        })
      );

  }

  public delete(action: string, params: any = {}, options: any = {}) {

    const url = `${this.apiUrl}`;
    const _options = {
      params: {
        action,
        ...params,
      },
      ...options
    };

    this.emitEvent(action, 'delete', 'pre', params);
    return this.http.delete(url, _options)
      .pipe(
        tap(() => this.emitEvent(action, 'delete', 'post', params)),
        catchError((err) => {
          this.emitEvent(action, 'delete', 'post', params);
          return throwError(err);
        })
      );

  }

  private emitEvent(scope, action, trigger, params = {}) {

    for (let key in this.loadingIndicator) {
      this.loadingIndicator[key].next({ scope, action, trigger, params });
    }

    // if (this.loadingIndicator[scope]) {
    //   this.loadingIndicator[scope].next({ scope, action, trigger, params });
    // }

    this.globalLoadingIndicator.next({ scope, action, trigger, params });

  }

}
